import { useEffect, useState } from 'react';
import './Header.css';
import logo from '../../../assests/internship/papa_internship_logo.png';
import { WhatsAppOutlined } from '@ant-design/icons';

const Header = () => {
    const [scrolled, setScrolled] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 50);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const toggleMenu = () => setMenuOpen(!menuOpen);

    return (
        <>
            <header className={`header ${scrolled ? 'scrolled' : ''}`}>
                <div className="header-content">
                    <div className="logo">
                        <img src={logo} alt="logo" style={{ width: "70px", height: "70px" }} />
                    </div>
                    <nav className="nav-desktop">
                        <a href="/">Home</a>
                        <a href="/about">About</a>
                        <a href="/courses">Courses</a>
                        <a href="/blog">Blogs</a>
                        <a href="/contact">Contact</a>
                    </nav>
                    <div className="menu-toggle" onClick={toggleMenu}>
                        ☰
                    </div>
                </div>
            </header>

            {/* Sidebar only for mobile */}
            <nav className={`sidebar ${menuOpen ? 'open' : ''}`}>
                <div className="close-btn" onClick={toggleMenu}>×</div>
                <a href="/">Home</a>
                <a href="/about">About</a>
                <a href="/courses">Courses</a>
                <a href="/blog">Blogs</a>
                <a href="#">Contact</a>
            </nav>

            {menuOpen && <div className="backdrop" onClick={toggleMenu}></div>}
            <a
                href="https://wa.me/919562121008"
                className="whatsapp-float"
                target="_blank"
                rel="noopener noreferrer"
            >
                <WhatsAppOutlined style={{ fontSize: '28px', }} className="fab fa-whatsapp" />
            </a>
        </>
    );
};

export default Header;
